import { type Asserts, object } from "yup";
import { IdArray } from "./shared";

export const CampaignRecipientsSchema = object({
  contactIds: IdArray,
  contactGroupIds: IdArray,
  excludedContactGroupIds: IdArray,
}).noUnknown();
export type CampaignRecipientsPayload = Asserts<typeof CampaignRecipientsSchema>;
